import type { MonitorPalette } from '../../chart/palette';
import { localDateTime } from '../../chart/format';
import type { Model, Svg } from '../model';
import type { Strings } from '../strings';

export const HISTORY_CLIP_ID = 'monitor-pipr-history-clip';

export function drawFrame(
    svg: Svg,
    model: Model,
    s: Strings,
    pal: MonitorPalette,
    historyLabel: string
): void {
    const { split, fwdW, plotTop, axisY, isNarrow, marginLeft, histW } =
        model.layout;

    svg.append('defs')
        .append('clipPath')
        .attr('id', HISTORY_CLIP_ID)
        .append('rect')
        .attr('x', marginLeft)
        .attr('y', 0)
        .attr('width', histW)
        .attr('height', model.layout.height);

    svg.append('rect')
        .attr('x', split)
        .attr('y', plotTop)
        .attr('width', fwdW)
        .attr('height', axisY - plotTop)
        .attr('fill', pal.forwardWash);

    svg.append('line')
        .attr('x1', split)
        .attr('x2', split)
        .attr('y1', plotTop - 12)
        .attr('y2', axisY)
        .attr('stroke', pal.ink)
        .attr('stroke-opacity', 0.55)
        .attr('stroke-width', 1);

    svg.append('text')
        .attr('x', split + 6)
        .attr('y', plotTop - 4)
        .attr('font-size', 10)
        .attr('fill', pal.inkMuted)
        .text(
            model.isLive
                ? s.today
                : `${s.asOfShort} ${localDateTime(model.asof)}`
        );

    if (!isNarrow) {
        svg.append('text')
            .attr('x', split - 6)
            .attr('y', plotTop - 4)
            .attr('text-anchor', 'end')
            .attr('font-size', 10)
            .attr('fill', pal.inkFaint)
            .text(historyLabel);
    }
}
